import { render, staticRenderFns } from "./EditServiceRequestTypeForm.vue?vue&type=template&id=3b1e4c95&scoped=true&"
import script from "./EditServiceRequestTypeForm.vue?vue&type=script&lang=js&"
export * from "./EditServiceRequestTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b1e4c95",
  null
  
)

export default component.exports